(function () {
  function getHeaderOffset() {
    var root = document.documentElement;
    var val = getComputedStyle(root).getPropertyValue('--ogt-lp-header-offset');
    var n = parseInt(val, 10);
    return Number.isFinite(n) ? n : 96;
  }

  function scrollToAnchor(id) {
    if (!id) return false;
    var target = document.getElementById(id);
    if (!target) return false;

    var offset = getHeaderOffset();
    var top =
      target.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    return true;
  }

  function onAnchorClick(event) {
    var link = event.target.closest('a[data-ogt-lp-anchor-scroll]');
    if (!link || !link.getAttribute('href')) return;

    var href = link.getAttribute('href');
    if (href.charAt(0) !== '#') return;

    var id = decodeURIComponent(href.slice(1));
    if (!id) return;

    var scrolled = scrollToAnchor(id);
    if (scrolled) {
      event.preventDefault();
      if (history.replaceState) {
        history.replaceState(null, '', href);
      } else {
        location.hash = href;
      }
    }
  }

  document.addEventListener('click', onAnchorClick);
})();
